<!-- 缴费弹框 -->
<template>
  <div class="container">
    <el-dialog center :visible.sync="dialogVisible" width="55%">
      <div class="title">缴费</div>
      <div style="padding: 0 0.24rem">
        <div class="box">
          <div class="btnsBox">
            <div
              class="btns"
              v-for="(item, keys) in member"
              :key="keys"
              @click="current = keys"
              :class="current === keys ? 'active' : ''"
            >
              {{ keys }}
            </div>
          </div>
          <div v-for="(item, keys) in member" :key="keys">
            <div v-if="current === keys" class="cardBox">
              <i
                @click="current = '黑钻会员'"
                :style="[current === '金钻会员' ? { color: '#CD6137' } : '']"
                style="font-size: 0.3rem; cursor: pointer"
                class="el-icon-arrow-left iocn"
              ></i>
              <div class="card">
                <div class="cardTop">
                  <img
                    style="position: absolute; right: 0.2rem; top: 0.2rem"
                    src="@/assets/png/vip.png"
                    alt=""
                  />
                  <p class="p1">{{ keys }}</p>
                  <p class="p2">升级攻略></p>
                  <p class="p3">{{ keys }}可以享受以下会员权益</p>
                </div>
                <div class="cardBottom">
                  <div
                    @click="current1 = item1.price"
                    class="selectBox"
                    :class="current1 === item1.price ? 'active1' : ''"
                    v-for="(item1, index) in item.priceList"
                    :key="index"
                  >
                    <div class="selectBoxTop">超值优惠还剩2天</div>
                    <div class="main">
                      <p class="p1">{{ item1.name }}</p>
                      <p class="p2">¥{{ item1.price }}</p>
                      <p class="p3">{{ item1.beforePrice }}</p>
                    </div>
                  </div>
                </div>
                <div class="jishao">
                  <p class="p1">商户特权</p>
                  <div class="div-sy">
                        {{ item.text }}
                  </div>
                </div>
              </div>
              <i
                @click="current = '金钻会员'"
                :style="[current === '黑钻会员' ? { color: '#CD6137' } : '']"
                style="font-size: 0.3rem; cursor: pointer"
                class="el-icon-arrow-right"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <el-button
        class="btns"
        size="small"
        slot="footer"
        type="primary"
        @click="dialogVisible = false"
        >立即购买</el-button
      >
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      member: {
        黑钻会员: {
          priceList: [
            {
              name: "月卡",
              price: 10,
              beforePrice: 20,
            },
            {
              name: "季卡",
              price: 28,
              beforePrice: 60,
            },
            {
              name: "年卡",
              price: 118,
              beforePrice: 240,
            },
          ],
          hierarchy: "vip",
          text: "比普通定制供应商提前5分钟看到询单，有效提高转化。",
        },
        金钻会员: {
          priceList: [
            {
              name: "月卡",
              price: 20,
              beforePrice: 50,
            },
            {
              name: "季卡",
              price: 58,
              beforePrice: 150,
            },
            {
              name: "年卡",
              price: 218,
              beforePrice: 600,
            },
          ],
          hierarchy: "vvip",
          text: "比普通定制供应商提前10分钟看到询单，有效提高转化",
        },
      },
      dialogVisible: false,
      current: "黑钻会员",
      current1: "",
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__header {
  padding: 0 !important;
}
/deep/ .el-dialog__body {
  padding: 0 !important;
}
/deep/ .el-dialog__footer {
  padding-bottom: 0.24rem !important;
}
.container {
  .active {
    background-color: #e4f4f3 !important;
  }
  .active1 {
    border: 2px solid red;
  }
  .title {
    height: 0.5rem;
    background-color: #e5f5f3;
    color: #000;
    padding-left: 0.24rem;
    text-align: left;
    line-height: 0.5rem;
    margin-bottom: 0.24rem;
  }
  .box {
    .btnsBox {
      display: flex;
      align-items: center;
      margin-bottom: 0.24rem;
      .btns {
        width: 1.6rem;
        height: 0.48rem;
        color: #4f2c08;
        background-color: #fff;
        line-height: 0.48rem;
        text-align: center;
        border: 1px solid #e5f4f3;
        margin-right: 0.24rem;
        border-radius: 5px;
      }
    }
  }
  .cardBox {
    display: flex;
    align-items: center;
    justify-content: center;
    .card {
      width: 7rem;
      height: 4rem;
      background-color: #e5f4f3;
      .cardTop {
        padding: 0.2rem;
        position: relative;
        .p1 {
          font-weight: bold;
          font-size: 0.2rem;
          color: #794000;
          margin-bottom: 5px;
        }
        .p2 {
          font-size: 0.12rem;
          cursor: pointer;
          display: inline-block;
          &:hover {
            border-bottom: 1px solid;
          }
        }
        .p3 {
          color: #000;
          font-size: 0.14rem;
          font-weight: bold;
          text-align: center;
        }
      }
      .cardBottom {
        background-color: #eef1f2;
        padding: 0.12rem 0.24rem;
        display: flex;
        align-items: center;
        margin-bottom: 0.24rem;

        .selectBox {
          width: 1.2rem;
          height: 1.4rem;
          background-color: #fbf4ea;
          cursor: pointer;
          margin-right: 0.2rem;
          display: flex;
          align-items: center;
          flex-direction: column;
          .selectBoxTop {
            font-size: 0.12rem;
            background-color: #eed092;
            color: #9b7934;
            text-align: center;
          }
          .main {
            flex: 1;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            .p1 {
              font-size: 0.12rem;
              color: #101010;
              font-weight: bold;
              margin-bottom: 6px;
            }
            .p2 {
              font-size: 0.14rem;
              font-weight: bold;
              color: #dc616f;
              margin-bottom: 6px;
            }
            .p3 {
              font-size: 0.1rem;
              font-weight: bold;
              text-decoration: line-through;
              color: #9f9f9f;
            }
          }
        }
      }
      .jishao {
        padding: 0 0.28rem;
        .p1 {
          font-size: 0.12rem;
          margin-bottom: 5px;
        }
        .div-sy {
          background: #fff;
          display: flex;
          border-radius: 0.1rem;
          padding: 0.08rem 0.16rem;
          align-items: center;
        }
      }
    }
  }
}
</style>
